import ActiveLink from "components/ActiveLink";

import { ActiveLinkStyle, InactiveLinkStyle } from "../MobileFooter";

import MobileBottomNavContent from "./MobileBottomNavContent";

type Props = {
  href: string;
  icon: any;
  text: string;
};

export default function MobileBottomNavLink({ href, text, icon }: Props) {
  return (
    <ActiveLink
      href={href}
      activeClassName={ActiveLinkStyle}
      className={InactiveLinkStyle}
      aria-current="page"
    >
      <MobileBottomNavContent icon={icon} text={text} />
    </ActiveLink>
  );
}
